import { Routes } from '@angular/router';
import { GraphViewComponent } from './features/graph-view/graph-view.component';
import { HomeComponent } from './features/home/home.component';
import { DatasetInfoComponent } from './features/objects/dataset-info/dataset-info.component';
import { SourceInfoComponent } from './features/objects/source-info/source-info.component';
import { ReportInfoComponent } from './features/objects/report-info/report-info.component';
import { DashboardInfoComponent } from './features/objects/dashboard-info/dashboard-info.component';
import { DataflowInfoComponent } from './features/objects/dataflow-info/dataflow-info.component';
import { CapacityInfoComponent } from './features/objects/capacity-info/capacity-info.component';

export const routes: Routes = [
    { path: '',   redirectTo: '/home', pathMatch: 'full' },
    { path: 'home', component: HomeComponent },
    { path: 'workspace/:workspaceId', component: GraphViewComponent },
    { path: 'capacity/:capacityId', component: CapacityInfoComponent },

    { path: 'workspace/:workspaceId/source/:sourceId', component: SourceInfoComponent },
    { path: 'workspace/:workspaceId/dataset/:datasetId', component: DatasetInfoComponent },
    { path: 'workspace/:workspaceId/report/:reportId', component: ReportInfoComponent },
    { path: 'workspace/:workspaceId/dashboard/:dashboardId', component: DashboardInfoComponent },
    { path: 'workspace/:workspaceId/dataflow/:dataflowId', component: DataflowInfoComponent },

];
